import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryEmailServerConfig(params) {
  return request({
    url: URL.sys.queryEmailServerConfig,
    method: 'post',
    params
  })
}

export function saveEmailServerConfig(data) {
  return request({
    url: URL.sys.saveEmailServerConfig,
    method: 'post',
    data
  })
}

export function deleteEmailServerConfig(data) {
  return request({
    url: URL.sys.deleteEmailServerConfig,
    method: 'post',
    data
  })
}
